/**
 * This is the starting point of your application.
 * Feature Hub Apps will use this file to bootstrap the app.
 */
import * as React from 'react';
import type { GfaServiceConfigProvider } from './feature-service-types';
import type { AudiFootnoteEngineContainerProps } from './components/audi-footnote-engine-container/audi-footnote-engine-container';
import AudiFootnoteEngineContainer from './components/audi-footnote-engine-container/audi-footnote-engine-container';

interface FeatureAppProps extends AudiFootnoteEngineContainerProps {
  configProvider: GfaServiceConfigProvider;
}

const FeatureApp: React.FC<FeatureAppProps> = ({
  apiUrls,
  audiUiTheme,
  disableBottomSpacing,
  disableSideSpacing,
  disclaimerManager,
  error,
  featureAppId,
  isServer,
  referenceServiceManager,
  footnoteService,
  layerElementClassName,
  footnoteData,
  dynamicFootnoteService,
  configProvider,
  isOneLayer,
  hasBackground = true,
}: AudiFootnoteEngineContainerProps) => {
  return (
    <AudiFootnoteEngineContainer
      apiUrls={apiUrls}
      audiUiTheme={audiUiTheme}
      disableBottomSpacing={disableBottomSpacing}
      disableSideSpacing={disableSideSpacing}
      disclaimerManager={disclaimerManager}
      error={error}
      featureAppId={featureAppId}
      isServer={isServer}
      referenceServiceManager={referenceServiceManager}
      footnoteService={footnoteService}
      layerElementClassName={layerElementClassName}
      footnoteData={footnoteData}
      dynamicFootnoteService={dynamicFootnoteService}
      configProvider={configProvider}
      isOneLayer={isOneLayer}
      hasBackground={hasBackground}
    />
  );
};

export default FeatureApp;
